import { Col, Row } from 'antd';
import React, { useContext, useEffect, useState } from 'react';

import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import AkcionarCard from 'components/molecules/Akcionar/AkcionarCard';

import prehledApi, { IPrehled } from 'services/akcionar/prehled';
import nastavitUcetApi from 'services/nastavitUcet';

interface IUdalostiAkcionar {}

const UdalostiAkcionar: React.FC<IUdalostiAkcionar> = () => {
    const { aktivniFirma } = useContext(Context);
    const [prehled, setPrehled] = useState<IPrehled[]>([]);
    const [errMessage, setErrMessage] = useState<string>();
    const [loading, setLoading] = useState<boolean>(false);
    useEffect(() => {
        setLoading(val => !val);
        nastavitUcetApi(aktivniFirma ? aktivniFirma.iducet : 0).then(() =>
            prehledApi()
                .then(resp => setPrehled(resp))
                .catch((err: any) => setErrMessage(err.response?.data.message))
                .finally(() => setLoading(val => !val))
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <Row gutter={8}>
            <Col span={24}>
                <LoadingWrapper loading={loading}>
                    {errMessage ? (
                        <Title text="AKCIONAR_ZADNE_UDALOSTI" level={3} />
                    ) : (
                        <AkcionarCard prehled={prehled} showButton={true} pocetDlazdic={10} />
                    )}
                </LoadingWrapper>
            </Col>
        </Row>
    );
};

export default UdalostiAkcionar;
